import styled from 'styled-components';

export const ColorSwatch = styled.div<{ $color: string; $selected?: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: ${(p) => p.$color};
  border: 1px solid rgba(0, 0, 0, 0.15);
  display: inline-block;
  cursor: pointer;
  outline: ${({ $selected, theme }) => ($selected ? `2px solid ${theme.colors.info}` : 'none')};
`;

export const ColCol = styled.th`
  width: 40px;
`;

export const ColOrder = styled.th`
  width: 80px;
`;

export const ColDefault = styled.th`
  width: 100px;
`;

export const ColActions = styled.th`
  width: 50px;
`;

export const ColorPickerInput = styled.input.attrs({ type: 'color' })`
  width: 50px;
  padding: 2px;
  height: 38px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radii.md};
  cursor: pointer;
`;
